var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progressdata-bars"},[_c('div',{staticClass:"round"}),_c('div',{staticClass:"bar"})])
}]

export { render, staticRenderFns }